<template>
    <div
        class="antialiased"
        id="app"
    >
        <component :is="layout">
            <router-view />
        </component>
    </div>
</template>

<style lang="scss">
    @import "./style/index.scss";

    body {
        font-family: "Inter",-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    }
</style>

<script>
const default_layout = "default";

export default {
    name: "App",
    computed: {
        layout() {
            return (this.$route.meta.layout || default_layout) + "-layout";
        },
    }
}
</script>
